<ion-toolbar class="main-header-toolbar">
    <app-header *ngIf="showParentDashboard"></app-header>
    <app-student-header *ngIf="showStudentDashboard"></app-student-header>
</ion-toolbar>

<ion-content [fullscreen]="true" class="content">

    <ion-grid fixed class="page-grid" [ngClass]="{'no-margin-top': showStudentDashboard, 'student-grid student-page': showStudentDashboard,}">

        <app-parent-dashboard *ngIf="showParentDashboard"></app-parent-dashboard>
        <app-student-dashboard *ngIf="showStudentDashboard"></app-student-dashboard>
    </ion-grid>

    <app-footer></app-footer>

</ion-content>


<app-chats [page]="true"></app-chats>
